import { RefreshCw } from "lucide-react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getMonths, syncNow, monthLabel } from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";

export default function PageHeader({ title, subtitle, month, setMonth, showControls = true }) {
  const qc = useQueryClient();
  const { data: months = [] } = useQuery({ queryKey: ["months"], queryFn: getMonths });

  const sync = useMutation({
    mutationFn: syncNow,
    onSuccess: (d) => {
      toast.success(`Gesynchroniseerd · ${d.transactions} sessies ingeladen`);
      qc.invalidateQueries();
    },
    onError: () => toast.error("Synchronisatie mislukt. Controleer de API-verbinding."),
  });

  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-2">
          {subtitle}
        </p>
        <h1 className="font-head text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
      </div>
      {showControls && (
        <div className="flex items-center gap-2.5">
          {month !== undefined && (
            <Select value={month} onValueChange={setMonth}>
              <SelectTrigger className="w-[170px] bg-card font-mono" data-testid="month-select">
                <SelectValue placeholder="Kies maand" />
              </SelectTrigger>
              <SelectContent>
                {months.map((m) => (
                  <SelectItem key={m} value={m} data-testid={`month-opt-${m}`}>
                    {monthLabel(m)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
          <Button
            data-testid="sync-btn"
            onClick={() => sync.mutate()}
            disabled={sync.isPending}
            className="gap-2"
          >
            <RefreshCw className={`h-4 w-4 ${sync.isPending ? "animate-spin" : ""}`} />
            Synchroniseer
          </Button>
        </div>
      )}
    </div>
  );
}
